import { render, staticRenderFns } from "./bs_date_select.vue?vue&type=template&id=b6db9d08&scoped=true&"
import script from "./bs_date_select.vue?vue&type=script&lang=coffee&"
export * from "./bs_date_select.vue?vue&type=script&lang=coffee&"
import style0 from "./bs_date_select.vue?vue&type=style&index=0&id=b6db9d08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6db9d08",
  null
  
)

export default component.exports